<template>
    <div>
        <email-validado v-if="$route.query.mode === 'verifyEmail'" />
        <reset-password v-if="$route.query.mode === 'resetPassword'" />
    </div>
</template>
<script>
import EmailValidado from '@/views/Email-validado.vue'
import ResetPassword from '@/views/ResetPassword.vue'
export default {
    name:'Email',
    components:{
        ResetPassword,
        EmailValidado
    }
}
</script>